<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Gerenciar espelhos de ponto</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Ano</label>
              <select class="form-control" v-model="search.year">
                <option :value="year" v-for="year in years" :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Mês</label>
              <select class="form-control" v-model="search.month">
                <option :value="month" v-for="month in months" :key="month">
                  {{ monthNames[month] }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6 mt-4">
            <div class="form-group">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="fired" v-model="search.fired" />
                <label class="custom-control-label" for="fired">Desligados?</label>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6 mt-4">
            <div class="form-group">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="closed" v-model="search.closed" />
                <label class="custom-control-label" for="closed">Fechados?</label>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 mt-4">
            <div class="form-group">
              <label style="visibility: hidden;">Ação</label>
              <button class="btn btn-info btn-block" @click="getEntity(1)" :disabled="loading || !search.year || !search.month">
                <span v-if="!loading">Buscar</span>
                <span v-else>Carregando...</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 d-flex align-items-center flex-wrap" style="gap: 8px;">
            <button class="btn btn-outline-secondary" @click="showFilters = !showFilters">
              {{ showFilters ? 'Ocultar Filtros' : 'Mostrar Filtros' }}
            </button>
            <button
              class="btn btn-outline-primary"
              @click="fetchAllClosed"
              :disabled="!search.year || !search.month || loadingAllClosed"
            >
              <i class="fas fa-download"></i>
              {{ loadingAllClosed ? 'Carregando...' : 'Baixar todos fechados' }}
            </button>
          </div>
        </div>
        <div class="row" v-show="showFilters">
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Filtrar Nome</label>
              <v-select
                v-model="filters.user_id"
                :options="allUsers"
                label="name"
                :reduce="user => user.id"
                placeholder="Selecione usuários..."
                :disabled="!search.year || !search.month"
                :loading="loadingUsers"
                multiple
                clearable
              />
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Filtrar Departamento</label>
              <input type="text" class="form-control" v-model="filters.department" placeholder="Digite o departamento..." />
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Filtrar Cargo</label>
              <input type="text" class="form-control" v-model="filters.role" placeholder="Digite o cargo..." />
            </div>
          </div>
        </div>
        
        <div class="row" v-show="showFilters">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Filtrar Últ. Mês Fechado</label>
              <input type="text" class="form-control" v-model="filters.lastClosedMonth" placeholder="Digite o mês..." />
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Filtrar Status</label>
              <select class="form-control" v-model="filters.status">
                <option value="">Todos</option>
                <option value="aberto">Aberto</option>
                <option value="fechado">Fechado</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Alocação</label>
              <v-select
                v-model="filters.alocation"
                :options="alocations"
                label="name"
                :reduce="alocation => alocation.id"
                placeholder="Selecione as alocações..."
                multiple
                clearable
              />
            </div>
          </div>
        </div>
        <div class="row mt-3 mb-4" v-show="showFilters">
          <div class="col-lg-2 col-md-3 col-sm-12">
            <button class="btn btn-block btn-primary" @click="applyFilters" :disabled="!canFilter">Filtrar</button>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-12">
            <button class="btn btn-block btn-outline-secondary" @click.prevent="clearFilters" :disabled="loading">Limpar</button>
          </div>
        </div>
        <!-- Barra de ação em lote -->
        <div
          v-if="selectedMirrors.length > 0"
          class="alert alert-info d-flex align-items-center justify-content-between mb-3"
          style="position: sticky; top: 0; z-index: 100;"
        >
          <span>
            <strong>{{ selectedMirrors.length }}</strong> espelho(s) selecionado(s)
          </span>
          <div class="d-flex align-items-center">
            <span v-if="downloading" class="mr-3 text-muted" style="font-size:13px">
              Baixando {{ downloadProgress.current }} de {{ downloadProgress.total }}...
            </span>
            <button
              class="btn btn-success btn-sm mr-2"
              @click="downloadSelected"
              :disabled="downloading"
            >
              <i class="fas fa-download"></i>
              {{ downloading ? 'Baixando...' : 'Baixar selecionados' }}
            </button>
            <button class="btn btn-outline-secondary btn-sm" @click="selectedMirrors = []">
              Limpar seleção
            </button>
          </div>
        </div>

        <div class="row">
          <!-- Table view for medium and larger screens -->
          <div class="col-12 d-none d-md-block">
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>                    
                    <th scope="col">Nome Colaborador</th>
                    <th scope="col">Cargo</th>
                    <th scope="col">Alocação</th>
                    <th scope="col">Status</th>
                    <th scope="col" v-if="hasSignature">Status Assinatura</th>
                    <th scope="col" style="text-align: center;">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in usersList" :key="user.id">                  
                    <td>{{ user.name }}</td>
                    <td>{{ user.role ? user.role.title : 'N/A' }}</td>
                    <td>{{ user.alocations_names || 'N/A' }}</td>
                    <td style="font-size: 16px; text-align: center">
                      <span v-if="!user.closed" class="badge badge-danger">Aberto</span>
                      <span v-else class="badge badge-success">Fechado</span>
                    </td>
                    <td style="font-size: 16px; text-align: center" v-if="hasSignature">
                      <span v-if="!user.signature_status" class="badge badge-danger">Não Assinado</span>
                      <span v-else class="badge badge-success">Assinado</span>

                      <span v-if="user.signature_status" style="font-size: 14px; text-align: center">
                        <a :href="user.signature_url" target="_blank">
                          <i class="fas fa-eye"></i> Visualizar Assinatura
                        </a>
                      </span>
                    </td>
                    <td>
                      <div class="d-flex flex-column">
                        <div class="btn-group mb-1" role="group" v-if="!user.closed">
                          <button
                            @click="close(user)"
                            class="btn btn-outline-primary btn-sm"
                            :title="'Fechar ' + user.name"
                          >
                            <i class="fas fa-check"></i>
                            <span class="ml-1">Fechar</span>
                          </button>
                          <button
                            @click="close(user, true)"
                            class="btn btn-outline-primary btn-sm"
                            :title="'Fechar em nova guia ' + user.name"
                          >
                            <i class="fas fa-external-link-alt"></i>
                          </button>
                        </div>

                        <div class="btn-group mb-1" role="group" v-else>
                          <button
                            @click="close(user)"
                            class="btn btn-outline-secondary btn-sm"
                            :title="'Visualizar ' + user.name"
                          >
                            <i class="fas fa-eye"></i>
                            <span class="ml-1">Visualizar</span>
                          </button>
                          <button
                            @click="close(user, true)"
                            class="btn btn-outline-secondary btn-sm"
                            :title="'Visualizar em nova guia ' + user.name"
                          >
                            <i class="fas fa-external-link-alt"></i>
                          </button>
                        </div>

                        <a
                          v-if="user.closed"
                          href="#"
                          @click.prevent="openMirror(user.mirror_id, user.name)"
                          class="btn btn-outline-info btn-sm mb-1"
                          :title="'Download ' + user.name"
                          rel="noopener noreferrer"
                        >
                          <i class="fas fa-download"></i>
                          <span class="ml-1">Download</span>
                        </a>

                        <button
                          v-if="user.closed"
                          @click="reopen(user.mirror_id)"
                          class="btn btn-outline-danger btn-sm"
                          :title="'Reabrir ' + user.name"
                        >
                          <i class="fas fa-trash"></i>
                          <span class="ml-1">Reabrir</span>
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr v-if="users.length == 0">
                    <td :colspan="hasSignature ? 10 : 9" align="center">
                      Nenhum registro encontrado.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Card view for small screens -->
          <div class="col-12 d-block d-md-none">
            <div v-if="usersList.length == 0" class="text-center">
              Nenhum registro encontrado.
            </div>
            <div v-for="user in usersList" :key="user.id" class="card mb-3">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <h5 class="card-title mb-0">{{ user.name }}</h5>
                  <input
                    v-if="user.closed"
                    type="checkbox"
                    :value="user.mirror_id"
                    v-model="selectedMirrors"
                    class="ml-2 mt-1"
                    :title="'Selecionar ' + user.name"
                  />
                </div>
                <p class="card-text">
                  <strong>Departamento:</strong> {{ user.department ? user.department.title : 'N/A' }}<br>
                  <strong>Cargo:</strong> {{ user.role ? user.role.title : 'N/A' }}<br>
                  <strong>Alocação:</strong> {{ user.alocations_names || 'N/A' }}<br>
                  <strong>Últ. Mês Fechado:</strong> {{ user.lastClosedMonth }}<br>
                  <strong>Período:</strong> {{ user.period }}<br>
                  <strong>Status:</strong>
                  <span v-if="!user.closed" class="badge badge-danger">Aberto</span>
                  <span v-else class="badge badge-success">Fechado</span>
                </p>
                <p v-if="hasSignature" class="card-text">
                  <strong>Status Assinatura:</strong>
                  <span v-if="!user.signature_status" class="badge badge-danger">Não Assinado</span>
                  <span v-else class="badge badge-success">Assinado</span>
                  <span v-if="user.signature_status">
                    <a :href="user.signature_url" target="_blank" class="ml-2">
                      <i class="fas fa-eye"></i> Visualizar
                    </a>
                  </span>
                </p>
                <div class="d-flex flex-wrap">
                  <button
                    v-if="!user.closed"
                    @click="close(user)"
                    class="btn btn-outline-primary btn-sm mr-1 mb-1"
                    :title="'Fechar ' + user.name"
                  >
                    <i class="fas fa-check"></i> Fechar
                  </button>

                  <button
                    v-else
                    @click="close(user)"
                    class="btn btn-outline-secondary btn-sm mr-1 mb-1"
                    :title="'Visualizar ' + user.name"
                  >
                    <i class="fas fa-eye"></i> Visualizar
                  </button>

                  <a
                    v-if="user.closed"
                    href="#"
                    @click.prevent="openMirror(user.mirror_id, user.name)"
                    class="btn btn-outline-info btn-sm mr-1 mb-1"
                    :title="'Download ' + user.name"
                    rel="noopener noreferrer"
                  >
                    <i class="fas fa-download"></i> Download
                  </a>

                  <button
                    v-if="user.closed"
                    @click="reopen(user.mirror_id)"
                    class="btn btn-outline-danger btn-sm mr-1 mb-1"
                    :title="'Reabrir ' + user.name"
                  >
                    <i class="fas fa-trash"></i> Reabrir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Paginação -->
        <div class="row mt-4" v-if="pagination.last_page > 1">
          <div class="col-12">
            <nav>
              <ul class="pagination justify-content-center">
                <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                  <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1)">
                    Anterior
                  </a>
                </li>
                
                <li 
                  class="page-item" 
                  :class="{ active: page === pagination.current_page }"
                  v-for="page in paginationPages" 
                  :key="page"
                >
                  <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                </li>
                
                <li class="page-item" :class="{ disabled: pagination.current_page === pagination.last_page }">
                  <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1)">
                    Próximo
                  </a>
                </li>
              </ul>
            </nav>
            
            <p class="text-center text-muted">
              Página {{ pagination.current_page }} de {{ pagination.last_page }} 
              ({{ pagination.total }} registros)
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de download em massa -->
    <div
      v-if="showDownloadModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0,0,0,0.5);"
      @click.self="showDownloadModal = false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fas fa-download mr-2"></i>Baixar espelhos fechados
            </h5>
            <button type="button" class="close" @click="showDownloadModal = false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                v-model="modalSearchQuery"
                placeholder="Buscar colaborador..."
                autofocus
              />
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <p class="mb-0 text-muted" style="font-size: 13px;">
                <span class="badge badge-primary">{{ pendingDownloadIds.length }}</span>
                de
                <span class="badge badge-secondary">{{ allClosedForDownload.length }}</span>
                selecionado(s)
              </p>
              <div>
                <button
                  class="btn btn-sm btn-outline-primary mr-2"
                  @click="pendingDownloadIds = allClosedForDownload.map(u => u.mirror_id)"
                >Selecionar todos</button>
                <button
                  class="btn btn-sm btn-outline-secondary"
                  @click="pendingDownloadIds = []"
                >Desmarcar todos</button>
              </div>
            </div>
            <div style="max-height: 360px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px;">
              <div
                v-for="user in filteredModalUsers"
                :key="user.mirror_id"
                class="d-flex align-items-center px-3 py-2 border-bottom"
                style="cursor: pointer;"
                @click="pendingDownloadIds.includes(user.mirror_id)
                  ? pendingDownloadIds.splice(pendingDownloadIds.indexOf(user.mirror_id), 1)
                  : pendingDownloadIds.push(user.mirror_id)"
              >
                <input
                  type="checkbox"
                  :value="user.mirror_id"
                  v-model="pendingDownloadIds"
                  class="mr-3"
                  @click.stop
                />
                <span>{{ user.name }}</span>
              </div>
              <div v-if="filteredModalUsers.length === 0" class="text-center text-muted py-4">
                Nenhum colaborador encontrado.
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showDownloadModal = false">Cancelar</button>
            <button
              class="btn btn-success"
              @click="confirmBulkDownload"
              :disabled="pendingDownloadIds.length === 0 || downloading"
            >
              <i class="fas fa-download mr-1"></i>
              Baixar {{ pendingDownloadIds.length }} espelho(s)
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      allUsers: [],
      loadingUsers: false,
      usersFilterLoaded: false,
      selectedMirrors: [],
      downloading: false,
      downloadProgress: { current: 0, total: 0 },
      showDownloadModal: false,
      allClosedForDownload: [],
      loadingAllClosed: false,
      pendingDownloadIds: [],
      modalSearchQuery: '',
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 50,
        total: 0
      },
      search: {
        year: null,
        month: null,
        fired: false,
        closed: false,
      },
      loading: false,
      filters: {
        user_id: [],
        department: '',
        role: '',
        lastClosedMonth: '',
        status: '',
        alocation: [],
      },
      alocations: [],
      showFilters: false,
      monthNames: [
        "",
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  computed: {
    usersList() {
      let list = this.users || [];
      if (!this.search.closed) {
        list = list.filter(function (user) {
          return user.closed == false;
        });
      }

      return list;
    },
    hasSignature() {
      return this.$store.getters.has_signature;
    },
    hasFilterValues() {
      const { user_id, department, role, lastClosedMonth, status, alocation } = this.filters;
      const hasTextFilters = [department, role, lastClosedMonth, status].some((value) => {
        return value !== null && value !== undefined && String(value).trim() !== "";
      });
      const hasUserFilter = Array.isArray(user_id) ? user_id.length > 0 : (user_id !== null && user_id !== undefined && user_id !== "");
      const hasAlocationFilter = Array.isArray(alocation) && alocation.length > 0;
      return hasUserFilter || hasTextFilters || hasAlocationFilter;
    },
    canFilter() {
      return !this.loading && this.usersList.length > 0 && this.hasFilterValues;
    },
    closedUsersList() {
      return this.usersList.filter(u => u.closed && u.mirror_id);
    },
    allClosedSelected() {
      return this.closedUsersList.length > 0 &&
        this.closedUsersList.every(u => this.selectedMirrors.includes(u.mirror_id));
    },
    someClosedSelected() {
      return this.closedUsersList.some(u => this.selectedMirrors.includes(u.mirror_id));
    },
    filteredModalUsers() {
      if (!this.modalSearchQuery.trim()) return this.allClosedForDownload;
      const q = this.modalSearchQuery.toLowerCase();
      return this.allClosedForDownload.filter(u => u.name && u.name.toLowerCase().includes(q));
    },
    years: function () {
      let lastYear = parseInt(moment().year(), 10);
      let availableYears = [];
      let firstYear = 2019;

      for (lastYear; lastYear >= firstYear; lastYear--) {
        availableYears.push(lastYear);
      }

      return availableYears;
    },
    months: function () {
      if (!this.search.year) return [];
      const thisYear = parseInt(moment().year(), 10);
      const availableMonths = [];
      const lastMonth = this.search.year === thisYear ? parseInt(moment().month(), 10) + 1 : 12;
      for (let monthIndex = 1; monthIndex <= lastMonth; monthIndex++) {
        availableMonths.push(monthIndex);
      }
      return availableMonths;
    },
    paginationPages() {
      const pages = [];
      const current = this.pagination.current_page;
      const last = this.pagination.last_page;
      
      if (last <= 10) {
        for (let i = 1; i <= last; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(last);
        } else if (current >= last - 3) {
          pages.push(1);
          pages.push('...');
          for (let i = last - 4; i <= last; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(last);
        }
      }
      
      return pages;
    }
  },
  methods: {
    downloadMirror: function (id) {
      const base = this.$store.state.url || '';
      const normalized = base.endsWith('/') ? base : base + '/';
      return (
        normalized +
        "export/point_mirror/" +
        id +
        "/Innov@AR3PointMirror2120INnv"
      );
    },
    applyFilters() {
      if (!this.canFilter) return;
      this.getEntity(1);
    },
    close(data, newTab = false) {
      const self = this;

      let obj = {
        year: self.search.year,
        month: self.search.month,
        user_id: data.id,
        closed: data.closed,
        mirror_id: data.mirror_id,
      };
      
      if (newTab) {
        const routeData = self.$router.resolve({
          path: '/point-mirror/view',
          query: {
            user_id: obj.user_id,
            month: obj.month,
            year: obj.year,
            closed: obj.closed ? '1' : '0',
            mirror_id: obj.mirror_id
          }
        });
        window.open(routeData.href, '_blank');
      } else {
        self.$store.commit("close_mirror", obj);
        self.$router.push("/point-mirror/view");
      }
    },
    getEntity: function (page = 1) {
      let self = this;
      let api = self.$store.state.api + "point-mirror/manager";

      this.loading = true;

      if (!self.search.year || !self.search.month) {
        this.loading = false;
        this.$message("Erro", "Selecione ano e mês antes de buscar", "error");
        return;
      }

      let payload = Object.assign({}, self.search, self.filters);
      payload.page = page;
      payload.per_page = 50;

      if (payload.hasOwnProperty('closed')) {
        delete payload.closed;
      }

      axios
        .post(api, payload)
        .then((response) => {
          self.users = response.data.data;
          self.selectedMirrors = [];
          self.pagination = {
            current_page: response.data.current_page,
            last_page: response.data.last_page,
            per_page: response.data.per_page,
            total: response.data.total
          };

          // Load filter options only after the main search completes.
          return self.loadActiveUsers();
        })
        .catch((error) => {
          self.errors = error.response && error.response.data ? error.response.data : error;
          self.$message(null, self.errors, "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      if (page >= 1 && page <= this.pagination.last_page && page !== '...') {
        this.getEntity(page);
      }
    },
    reopen: function (id) {
      let self = this;
      let api = self.$store.state.api + "point-mirror/reopen";

      axios
        .post(api, { id: id })
        .then((response) => {
          self.$message(null, "Espelho de ponto reaberto", "success");
          self.getEntity(self.pagination.current_page);
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    clearFilters() {
      this.filters = {
        user_id: [],
        department: '',
        role: '',
        lastClosedMonth: '',
        status: '',
        alocation: [],
      };
      this.getEntity(1);
    },
    loadActiveUsers(force = false) {
      const self = this;
      const api = self.$store.state.api + "users/active";

      if (self.loadingUsers) {
        return Promise.resolve();
      }

      if (self.usersFilterLoaded && !force) {
        return Promise.resolve();
      }

      self.loadingUsers = true;

      return axios.get(api)
        .then((response) => {
          self.allUsers = (response.data && response.data.data) ? response.data.data : response.data;
          self.usersFilterLoaded = true;
        })
        .catch(() => {
          self.allUsers = [];
          self.usersFilterLoaded = false;
        })
        .finally(() => {
          self.loadingUsers = false;
        });
    },
    toggleSelectAll() {
      if (this.allClosedSelected) {
        const ids = this.closedUsersList.map(u => u.mirror_id);
        this.selectedMirrors = this.selectedMirrors.filter(id => !ids.includes(id));
      } else {
        const ids = this.closedUsersList.map(u => u.mirror_id);
        ids.forEach(id => {
          if (!this.selectedMirrors.includes(id)) this.selectedMirrors.push(id);
        });
      }
    },
    async downloadSelected() {
      if (this.downloading || this.selectedMirrors.length === 0) return;
      this.downloading = true;
      this.downloadProgress = { current: 0, total: this.selectedMirrors.length };

      // Pre-check which files actually exist on the server
      let toDownload = [...this.selectedMirrors];
      try {
        const checkResponse = await axios.post(
          this.$store.state.api + 'point-mirror/check-files',
          { ids: this.selectedMirrors }
        );
        const { found, missing } = checkResponse.data;
        toDownload = found;

        if (missing && missing.length > 0) {
          const missingNames = missing.map(id => {
            const u = this.usersList.find(u => u.mirror_id === id)
              || this.allClosedForDownload.find(u => u.mirror_id === id);
            return u ? u.name : 'ID ' + id;
          });
          this.$message(
            null,
            'Arquivo não encontrado para: ' + missingNames.join(', '),
            'warning'
          );
        }
      } catch (e) {
        // If check fails, proceed with all IDs and let browser handle errors
      }

      this.downloadProgress.total = toDownload.length;

      const doDownload = (index) => {
        if (index >= toDownload.length) {
          this.downloading = false;
          this.selectedMirrors = [];
          return;
        }
        const mirrorId = toDownload[index];
        try {
          const url = this.downloadMirror(mirrorId);
          const a = document.createElement('a');
          a.href = url;
          a.rel = 'noopener noreferrer';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } catch (e) {
          this.$message(null, 'Erro ao iniciar download', 'error');
        }
        this.downloadProgress.current = index + 1;
        setTimeout(() => doDownload(index + 1), 400);
      };

      doDownload(0);
    },
    openMirror(id) {
      const url = this.downloadMirror(id);
      const a = document.createElement('a');
      a.href = url;
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async fetchAllClosed() {
      if (!this.search.year || !this.search.month) return;
      this.loadingAllClosed = true;
      const api = this.$store.state.api + 'point-mirror/manager';
      const payload = Object.assign({}, this.search, this.filters, {
        status: 'fechado',
        per_page: 9999,
        page: 1,
      });
      if (payload.hasOwnProperty('closed')) delete payload.closed;
      try {
        const response = await axios.post(api, payload);
        const raw = (response.data && response.data.data) ? response.data.data : response.data;
        this.allClosedForDownload = Array.isArray(raw)
          ? raw.filter(u => u.closed && u.mirror_id)
          : [];
        this.pendingDownloadIds = this.allClosedForDownload.map(u => u.mirror_id);
        this.modalSearchQuery = '';
        this.showDownloadModal = true;
      } catch (e) {
        this.$message(null, 'Erro ao carregar espelhos fechados', 'error');
      } finally {
        this.loadingAllClosed = false;
      }
    },
    confirmBulkDownload() {
      this.showDownloadModal = false;
      this.selectedMirrors = [...this.pendingDownloadIds];
      this.downloadSelected();
    },
    loadAlocations() {
      const self = this;
      const api = self.$store.state.api + "alocations/";
      axios.get(api)
        .then((response) => {
          self.alocations = (response.data && response.data.data) ? response.data.data : response.data;
        })
        .catch(() => {
          self.alocations = [];
        });
    },
  },
  mounted: function () {
    const self = this;
    var closeMirror = this.$store.getters.getCloseMirror;

    self.loadAlocations();

    if (closeMirror) {
      self.search.year = closeMirror.year;
      self.search.month = closeMirror.month;
    }

    if (self.$route.params.month && self.$route.params.year) {
      self.search.year = self.$route.params.year;
      self.search.month = Number(self.$route.params.month);
    }
  },
};
</script>
